import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .tloader {\n      .tloader-body {\n        .c7n-list {\n          &.c7n-list .c7n-spin-nested-loading .c7n-spin-container .c7n-list-item {\n            padding: 0;\n          }\n          .c7n-list-item {\n            background-color: #fff;\n\n            &:hover {\n              background: ", ";\n              .item-header {\n                span {\n                  color: ", ";\n                }\n              }\n            }\n            .c7n-list-item-content {\n              .list-item-active {\n                background: ", ";\n                .item-header {\n                  span {\n                    color: ", ";\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import { css } from 'styled-components';
import { getThemeData, hexToRgbaColor } from '@hzero-front-ui/core';
function getCommonCompCss(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  return css(_templateObject(), hexToRgbaColor(primary, 0.1), primary, hexToRgbaColor(primary, 0.1), primary);
}
export default css(_templateObject2(), getCommonCompCss);